var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForgotPwd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 268.243,
    viewBox: "0 0 360 268.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458",
    transform: "translate(0 -20.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Forgot_password-rafiki",
    "data-name": "Forgot password-rafiki",
    transform: "translate(0 -34.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-119",
    transform: "translate(0 55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 360,
    height: 0.18,
    transform: "translate(0 235.728)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 18.331,
    height: 0.18,
    transform: "translate(208.951 240.631)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 43.438,
    height: 0.18,
    transform: "translate(284.479 244.526)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 44.878,
    height: 0.18,
    transform: "translate(160.171 240.718)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 9.389,
    height: 0.18,
    transform: "translate(121.68 246.103)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 42.754,
    height: 0.18,
    transform: "translate(140.191 246.103)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    width: 27.684,
    height: 0.18,
    transform: "translate(37.771 243.065)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M181.339,258.616H42.314a4.111,4.111,0,0,1-4.1-4.111V59.075A4.111,4.111,0,0,1,42.314,55H181.339a4.111,4.111,0,0,1,4.111,4.111V254.5A4.111,4.111,0,0,1,181.339,258.616ZM42.314,55.144a3.931,3.931,0,0,0-3.924,3.931V254.5a3.931,3.931,0,0,0,3.924,3.931H181.339a3.938,3.938,0,0,0,3.931-3.931V59.075a3.938,3.938,0,0,0-3.931-3.931Z",
    transform: "translate(-10.699 -55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M397.643,258.616H258.611A4.118,4.118,0,0,1,254.5,254.5V59.075A4.118,4.118,0,0,1,258.611,55H397.643a4.111,4.111,0,0,1,4.1,4.075V254.5A4.111,4.111,0,0,1,397.643,258.616ZM258.611,55.144a3.938,3.938,0,0,0-3.931,3.931V254.5a3.938,3.938,0,0,0,3.931,3.931H397.643a3.938,3.938,0,0,0,3.931-3.931V59.075a3.938,3.938,0,0,0-3.931-3.931Z",
    transform: "translate(-71.26 -55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    d: "M176.24,282.65H128.432l-2.9-33.48h47.808Z",
    transform: "translate(-35.148 -109.368)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    d: "M179.68,282.65H131.872l-2.9-33.48h47.808Z",
    transform: "translate(-36.112 -109.368)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2558",
    "data-name": "Path 2558",
    d: "M141.458,278.252l-1.6-19.1h33.43l1.6,19.1Z",
    transform: "translate(-39.161 -112.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_314",
    "data-name": "Rectangle 314",
    width: 5.609,
    height: 62.446,
    transform: "translate(146.232 173.282)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_315",
    "data-name": "Rectangle 315",
    width: 3.895,
    height: 62.446,
    transform: "translate(149.717 173.282)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_316",
    "data-name": "Rectangle 316",
    width: 54.295,
    height: 6.89,
    transform: "translate(153.612 180.173) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    "data-name": "Rectangle 317",
    width: 5.609,
    height: 55.555,
    transform: "translate(95.623 180.173)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    "data-name": "Rectangle 318",
    width: 3.895,
    height: 55.555,
    transform: "translate(99.108 180.173)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 5.609,
    height: 55.555,
    transform: "translate(55.699 180.173)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 3.895,
    height: 55.555,
    transform: "translate(59.184 180.173)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_321",
    "data-name": "Rectangle 321",
    width: 5.609,
    height: 55.555,
    transform: "translate(110.736 180.173)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    width: 3.895,
    height: 55.555,
    transform: "translate(114.214 180.173)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_323",
    "data-name": "Rectangle 323",
    width: 43.618,
    height: 6.89,
    transform: "translate(55.699 173.282)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 168.718,
    height: 93.931,
    transform: "translate(93.247 17.575)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_325",
    "data-name": "Rectangle 325",
    width: 177.134,
    height: 93.931,
    transform: "translate(94.097 17.575)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_326",
    "data-name": "Rectangle 326",
    width: 88.142,
    height: 171.346,
    transform: "translate(268.337 20.47) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2559",
    "data-name": "Path 2559",
    d: "M210.308,171.572l32.35-88.142H189.27l-32.35,88.142Z",
    transform: "translate(-43.938 -62.96)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2560",
    "data-name": "Path 2560",
    d: "M286.777,171.572l32.35-88.142H278.85L246.5,171.572Z",
    transform: "translate(-69.02 -62.96)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_327",
    "data-name": "Rectangle 327",
    width: 14.342,
    height: 89.712,
    transform: "translate(301.097 146.016)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2561",
    "data-name": "Path 2561",
    d: "M431.333,379.715h3.773v-6.9H427.38Z",
    transform: "translate(-119.666 -143.987)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_328",
    "data-name": "Rectangle 328",
    width: 14.342,
    height: 89.712,
    transform: "translate(168.862 146.016)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_329",
    "data-name": "Rectangle 329",
    width: 135.526,
    height: 87.847,
    transform: "translate(179.914 146.016)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2562",
    "data-name": "Path 2562",
    d: "M383.842,287.521H253.45V262.71H383.842ZM254.17,286.8H383.122V263.43H254.17Z",
    transform: "translate(-70.966 -113.159)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2563",
    "data-name": "Path 2563",
    d: "M366.782,275.965H284.825c-3.8,0-7.466-3.067-10.08-8.424l-.245-.511H377.1l-.245.511C374.22,272.9,370.62,275.965,366.782,275.965Zm-91.1-8.237c2.434,4.774,5.76,7.5,9.144,7.5h81.958c3.4,0,6.71-2.722,9.144-7.5Z",
    transform: "translate(-76.86 -114.368)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2564",
    "data-name": "Path 2564",
    d: "M253.653,379.715H249.88v-6.9h7.726Z",
    transform: "translate(-69.966 -143.987)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2565",
    "data-name": "Path 2565",
    d: "M383.842,326.362H253.45V301.58H383.842Zm-129.672-.72H383.122V302.3H254.17Z",
    transform: "translate(-70.966 -124.042)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    d: "M366.782,314.832H284.825c-3.8,0-7.466-3.074-10.08-8.424l-.245-.518H377.1l-.245.518C374.22,311.729,370.62,314.832,366.782,314.832Zm-91.1-8.222c2.434,4.774,5.76,7.5,9.144,7.5h81.958c3.4,0,6.71-2.729,9.144-7.5Z",
    transform: "translate(-76.86 -125.249)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    d: "M383.842,365.251H253.45V340.44H383.842Zm-129.672-.72H383.122V341.16H254.17Z",
    transform: "translate(-70.966 -134.923)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2568",
    "data-name": "Path 2568",
    d: "M366.782,353.7H284.825c-3.8,0-7.466-3.067-10.08-8.417l-.245-.518H377.1l-.245.518C374.22,350.628,370.62,353.7,366.782,353.7Zm-91.1-8.215c2.434,4.774,5.76,7.5,9.144,7.5h81.958c3.4,0,6.71-2.722,9.144-7.5Z",
    transform: "translate(-76.86 -136.133)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2569",
    "data-name": "Path 2569",
    d: "M114.126,274.28v1.742h-1.109l-.922,13.658H98.53l-.914-13.658H96.5V274.28Z",
    transform: "translate(-27.02 -116.398)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    d: "M97.854,221.095c-1.109-8.136-12.089-10.454-26.021-10.757-13.255-.281-17.5-4.968-17.5-4.968s.043,18.986,19.145,25.87C91.612,237.763,98.97,229.245,97.854,221.095Z",
    transform: "translate(-15.212 -97.104)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    d: "M105.368,249.13c.23-3.341,5.573-9.49,18.425-6.7,9.288,2.023,12.744-2.794,12.744-2.794s-.864,13.594-14.832,17.676C108.435,261.2,104.957,255.019,105.368,249.13Z",
    transform: "translate(-29.494 -106.699)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2572",
    "data-name": "Path 2572",
    d: "M108.03,265.475a.5.5,0,0,0,.382-.173c.929-1.1.166-3.737-.886-7.387-1.354-4.68-3.038-10.512-1.613-14.738a59.284,59.284,0,0,1,2.765-6.538c2.016-4.262,3.758-7.92,2.3-11.794a.5.5,0,1,0-.929.353c1.3,3.449-.274,6.79-2.275,11.023a61.624,61.624,0,0,0-2.808,6.638c-1.519,4.522.209,10.519,1.6,15.329.821,2.88,1.67,5.76,1.087,6.48a.49.49,0,0,0,.058.72A.475.475,0,0,0,108.03,265.475Z",
    transform: "translate(-29.226 -102.467)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-119",
    transform: "translate(40.399 306.942)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-119",
    cx: 139.601,
    cy: 8.15,
    rx: 139.601,
    ry: 8.15,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Login--inject-119",
    transform: "translate(72.137 105.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2573",
    "data-name": "Path 2573",
    d: "M208.024,297.106H105.784L100.19,132.68H202.43Z",
    transform: "translate(-100.19 -127.575)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2574",
    "data-name": "Path 2574",
    d: "M215.112,290.016H112.872l-5.6-164.426H209.51Z",
    transform: "translate(-102.172 -125.59)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2575",
    "data-name": "Path 2575",
    d: "M215.112,290.016H112.872l-5.6-164.426H209.51Z",
    transform: "translate(-102.172 -125.59)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 28.274,
    cy: 29.254,
    rx: 28.274,
    ry: 29.254,
    transform: "matrix(0.701, -0.713, 0.713, 0.701, 17.139, 46.808)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2576",
    "data-name": "Path 2576",
    d: "M195,181.85a23.04,23.04,0,0,1-2.484,11.3,22.745,22.745,0,0,1-20.448,12.427,24.667,24.667,0,0,1-21.283-12.427,24.113,24.113,0,0,1-3.254-11.3,22.781,22.781,0,0,1,22.925-23.76A24.739,24.739,0,0,1,195,181.85Z",
    transform: "translate(-113.44 -134.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2577",
    "data-name": "Path 2577",
    d: "M193.771,204.329a22.745,22.745,0,0,1-20.448,12.427,24.667,24.667,0,0,1-21.283-12.427A36.425,36.425,0,0,1,172.7,198,38.505,38.505,0,0,1,193.771,204.329Z",
    transform: "translate(-114.708 -145.865)",
    fill: "#90caf9",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 10.397,
    cy: 10.757,
    rx: 10.397,
    ry: 10.757,
    transform: "matrix(0.701, -0.713, 0.713, 0.701, 42.588, 38.9)",
    fill: "#90caf9",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2578",
    "data-name": "Path 2578",
    d: "M202.987,266.22H137.769l-.439-12.96h65.218Z",
    transform: "translate(-110.589 -161.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2579",
    "data-name": "Path 2579",
    d: "M204.084,298.39H138.859l-.439-12.96h65.225Z",
    transform: "translate(-110.894 -170.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2580",
    "data-name": "Path 2580",
    d: "M188.17,287.906l-15.718,2.16a1.094,1.094,0,0,0-.95,1.3l2.066,10.534a1.267,1.267,0,0,0,1.4.986l15.718-2.16a1.1,1.1,0,0,0,.943-1.3l-2.059-10.534A1.26,1.26,0,0,0,188.17,287.906Zm-4.514,10.67-2.88.382-.281-3.4a2.016,2.016,0,0,1-1.174-1.44,1.793,1.793,0,0,1,1.555-2.16,2.059,2.059,0,0,1,2.275,1.606,1.764,1.764,0,0,1-.562,1.678Z",
    transform: "translate(-120.152 -171.035)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2581",
    "data-name": "Path 2581",
    d: "M186.863,283.741h0a1.123,1.123,0,0,1-1.238-.871l-.2-1.03a5.926,5.926,0,0,0-6.206-4.723,5.04,5.04,0,0,0-4.651,6.041l.23,1.188a.965.965,0,0,1-.842,1.152h0a1.109,1.109,0,0,1-1.238-.871l-.194-1a7.092,7.092,0,0,1,5.76-8.46,8.064,8.064,0,0,1,9.216,6.242l.23,1.181a.965.965,0,0,1-.864,1.152Z",
    transform: "translate(-120.4 -167.44)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2582",
    "data-name": "Path 2582",
    d: "M198.049,325.358H155.591l-.281-8.438h42.451Z",
    transform: "translate(-115.624 -179.162)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2583",
    "data-name": "Path 2583",
    d: "M184.374,261.339a2.275,2.275,0,0,1-2.29,2.369,2.477,2.477,0,0,1-2.455-2.369,2.275,2.275,0,0,1,2.29-2.369,2.47,2.47,0,0,1,2.455,2.369Z",
    transform: "translate(-122.432 -162.936)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2584",
    "data-name": "Path 2584",
    d: "M170.157,261.339a2.268,2.268,0,0,1-2.29,2.369,2.47,2.47,0,0,1-2.448-2.369,2.275,2.275,0,0,1,2.29-2.369,2.462,2.462,0,0,1,2.448,2.369Z",
    transform: "translate(-118.454 -162.936)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2585",
    "data-name": "Path 2585",
    d: "M156.027,261.339a2.275,2.275,0,0,1-2.29,2.369,2.462,2.462,0,0,1-2.448-2.369,2.275,2.275,0,0,1,2.29-2.369A2.462,2.462,0,0,1,156.027,261.339Z",
    transform: "translate(-114.497 -162.936)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2586",
    "data-name": "Path 2586",
    d: "M198.547,261.347a2.275,2.275,0,0,1-2.29,2.369,2.462,2.462,0,0,1-2.448-2.369,2.268,2.268,0,0,1,2.3-2.347A2.462,2.462,0,0,1,198.547,261.347Z",
    transform: "translate(-126.403 -162.945)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2587",
    "data-name": "Path 2587",
    d: "M212.717,261.339a2.268,2.268,0,0,1-2.29,2.369,2.47,2.47,0,0,1-2.448-2.369,2.275,2.275,0,0,1,2.29-2.369A2.462,2.462,0,0,1,212.717,261.339Z",
    transform: "translate(-130.37 -162.936)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-119",
    transform: "translate(198.951 107.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2588",
    "data-name": "Path 2588",
    d: "M331.354,174.28c.958,1.541,1.757,3.01,2.578,4.543s1.562,3.074,2.29,4.651a66.5,66.5,0,0,1,3.672,9.886c.13.425.223.878.331,1.318l.158.67.079.331.094.547a9.85,9.85,0,0,1-.223,3.715,21.054,21.054,0,0,1-2.246,5.364,42.639,42.639,0,0,1-6.394,8.374l-3.031-2.29a80.2,80.2,0,0,0,4.054-8.64,17.9,17.9,0,0,0,1.1-4.054,3.211,3.211,0,0,0-.058-1.274l-.288-.878c-.115-.36-.223-.72-.36-1.087a81.65,81.65,0,0,0-3.794-8.7c-1.44-2.88-2.988-5.76-4.536-8.51Z",
    transform: "translate(-289.889 -140.634)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    d: "M329.952,224.43l-3.312,1.75,3.8,4.45s2.376-1.606,2.484-4.054Z",
    transform: "translate(-290.41 -154.676)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    d: "M320.47,229.6l4.068,3.233,4.176-1.526-3.8-4.45Z",
    transform: "translate(-288.683 -155.357)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M300.772,141.235c-.079.4-.36.684-.619.634s-.41-.425-.331-.821.36-.72.626-.634S300.851,140.832,300.772,141.235Z",
    transform: "translate(-282.895 -131.148)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M299.686,142.52a14.585,14.585,0,0,1-2.606,3.038,2.369,2.369,0,0,0,1.843.72Z",
    transform: "translate(-282.133 -131.742)",
    fill: "#ff5652"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M298.9,160.3V155.58l6.25.72s-.1,4.061-3.6,5.256Z",
    transform: "translate(-282.643 -135.398)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2594",
    "data-name": "Path 2594",
    d: "M300.711,150.86l4.4,1.267.079,2.887-6.25-.756Z",
    transform: "translate(-282.654 -134.077)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2595",
    "data-name": "Path 2595",
    d: "M305.466,152.127l-4.4-1.267-.857,1.642a7.006,7.006,0,0,0,4.061,6.106,6.883,6.883,0,0,0,1.274-3.6Z",
    transform: "translate(-283.01 -134.077)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    d: "M303.008,138.42a.245.245,0,0,0,.18-.4,2.39,2.39,0,0,0-2.045-.792.238.238,0,0,0-.194.274.245.245,0,0,0,.274.2h0a1.894,1.894,0,0,1,1.613.641.245.245,0,0,0,.173.079Z",
    transform: "translate(-283.216 -130.255)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M312.259,151.68c-.72,3.708-1.166,8.842,1.44,11.311,0,0-1.008,3.758-7.92,3.758-7.567,0-3.636-3.3-3.636-3.3,3.146-.979,3.118-4.558,2.4-7.438Z",
    transform: "translate(-283.265 -134.306)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M315.2,168.823c.677-.95.648-3.967-.072-4.5-1.159-.857-6.134-1.058-12.823.482a4.707,4.707,0,0,1-.828,4.45Z",
    transform: "translate(-283.365 -137.661)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2599",
    "data-name": "Path 2599",
    d: "M351.246,407.822a1.648,1.648,0,0,1-1.267-.072.49.49,0,0,1-.115-.554.554.554,0,0,1,.31-.353c.684-.331,2.254.31,2.326.338a.115.115,0,0,1,.072.108.137.137,0,0,1-.065.115A7.079,7.079,0,0,1,351.246,407.822Zm-.828-.814a.6.6,0,0,0-.137.05.3.3,0,0,0-.187.2c-.065.216,0,.288.043.31.274.23,1.282,0,1.994-.266A3.953,3.953,0,0,0,350.418,407.009Z",
    transform: "translate(-296.901 -205.726)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M352.782,406.879h-.058c-.576-.166-1.8-1.037-1.814-1.606a.4.4,0,0,1,.31-.389.619.619,0,0,1,.526.043c.677.346,1.109,1.742,1.123,1.807a.115.115,0,0,1,0,.115A.1.1,0,0,1,352.782,406.879Zm-1.44-1.793h-.058c-.144.05-.144.122-.144.158,0,.338.821,1.022,1.44,1.3a3,3,0,0,0-.922-1.44.417.417,0,0,0-.31-.014Z",
    transform: "translate(-297.206 -205.193)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    d: "M299.251,408.945c-.648,0-1.274-.094-1.483-.382a.454.454,0,0,1,0-.526.6.6,0,0,1,.382-.281c.842-.23,2.614.778,2.686.821a.108.108,0,0,1,.058.122.115.115,0,0,1-.094.1A8.786,8.786,0,0,1,299.251,408.945Zm-.8-.986a.721.721,0,0,0-.23,0,.367.367,0,0,0-.238.166c-.086.151-.05.223,0,.266.238.331,1.512.338,2.455.2a5.48,5.48,0,0,0-1.987-.634Z",
    transform: "translate(-282.302 -205.998)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2602",
    "data-name": "Path 2602",
    d: "M301.306,408.333h-.05c-.612-.274-1.822-1.368-1.728-1.944,0-.137.115-.3.446-.331a.864.864,0,0,1,.662.2,3.441,3.441,0,0,1,.792,1.951.144.144,0,0,1-.05.108A.137.137,0,0,1,301.306,408.333Zm-1.238-2.052H300c-.216,0-.23.1-.23.13-.058.346.763,1.21,1.39,1.584a2.786,2.786,0,0,0-.67-1.562.634.634,0,0,0-.425-.151Z",
    transform: "translate(-282.817 -205.531)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2603",
    "data-name": "Path 2603",
    d: "M307.556,404.5h-5.062l-.5-11.729h5.062Z",
    transform: "translate(-283.508 -201.812)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2604",
    "data-name": "Path 2604",
    d: "M357.492,401.552l-4.946,1.073L347.57,391.7l4.954-1.073Z",
    transform: "translate(-296.271 -201.212)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2605",
    "data-name": "Path 2605",
    d: "M351.011,406.129l5.566-1.2a.439.439,0,0,1,.49.245l1.93,4.19a.72.72,0,0,1-.533,1.037c-1.944.382-2.916.475-5.357,1-1.5.331-4.9,1.159-6.984,1.606s-2.794-1.548-1.98-1.915c3.636-1.663,5.148-3.125,6.134-4.486A1.231,1.231,0,0,1,351.011,406.129Z",
    transform: "translate(-295.219 -205.213)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2606",
    "data-name": "Path 2606",
    d: "M297.987,408.24h5.53a.446.446,0,0,1,.432.346l1,4.5a.72.72,0,0,1-.72.907c-1.994-.036-4.874-.151-7.38-.151-2.938,0-5.465.158-8.906.158-2.081,0-2.657-2.1-1.786-2.3,3.96-.864,7.2-.958,10.62-3.067a2.355,2.355,0,0,1,1.21-.4Z",
    transform: "translate(-278.965 -206.143)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2607",
    "data-name": "Path 2607",
    d: "M328.689,168.946c4.745,1.087,8.64,13.2,8.64,13.2l-9.482,7.25a20.83,20.83,0,0,1-5.04-9.36C321.129,173.691,323.836,167.823,328.689,168.946Z",
    transform: "translate(-289.197 -139.102)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2608",
    "data-name": "Path 2608",
    d: "M328.689,168.946c4.745,1.087,8.64,13.2,8.64,13.2l-9.482,7.25a20.83,20.83,0,0,1-5.04-9.36C321.129,173.691,323.836,167.823,328.689,168.946Z",
    transform: "translate(-289.197 -139.102)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2609",
    "data-name": "Path 2609",
    d: "M290.85,180.692c-1.181,1.274-2.362,2.412-3.6,3.6-.612.576-1.231,1.152-1.865,1.706l-.958.842-.238.209-.41.331a5.759,5.759,0,0,1-1.39.821,4.529,4.529,0,0,1-1.757.36,4.32,4.32,0,0,1-1.512-.266,4.255,4.255,0,0,1-1.44-.914,4.32,4.32,0,0,1-1.123-1.865,4.9,4.9,0,0,1-.209-1.073,7.269,7.269,0,0,1,0-1.282c.036-.346.079-.648.137-.929a17.827,17.827,0,0,1,.835-2.88,25.782,25.782,0,0,1,1.116-2.606c.461-.914.9-1.584,1.339-2.347a58.791,58.791,0,0,1,6.084-8.251,55.744,55.744,0,0,1,7.38-7l2.65,2.729c-1.858,2.491-3.686,5.162-5.378,7.79a84.426,84.426,0,0,0-4.608,8.1c-.31.677-.72,1.44-.914,1.987a19.315,19.315,0,0,0-.67,1.944,12.565,12.565,0,0,0-.41,1.814,2.833,2.833,0,0,0,0,.288v-.065a2,2,0,0,0-.094-.475,3.089,3.089,0,0,0-.828-1.339,3.529,3.529,0,0,0-1.188-.72,3.442,3.442,0,0,0-1.21-.223,2.938,2.938,0,0,0-1.159.223,2.648,2.648,0,0,0-.36.18l.274-.252.871-.792,1.721-1.613c1.138-1.073,2.282-2.218,3.362-3.283Z",
    transform: "translate(-276.321 -136.398)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2610",
    "data-name": "Path 2610",
    d: "M324.7,181.36c2.578,2.549,3.42,7.2,3.6,11.232l-.418.324a20.829,20.829,0,0,1-5.04-9.36c-.094-.374-.18-.72-.245-1.13Z",
    transform: "translate(-289.279 -142.617)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2611",
    "data-name": "Path 2611",
    d: "M289.173,173.517c-1.037,5.472-1.685,16.711,1.318,38.959h27.115c.187-4.154-2.426-24.444,1.584-44.035a71.286,71.286,0,0,0-9.072-1.145,100.607,100.607,0,0,0-11.52,0c-1.267.115-2.52.3-3.6.5A7.2,7.2,0,0,0,289.173,173.517Z",
    transform: "translate(-279.677 -138.633)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2612",
    "data-name": "Path 2612",
    d: "M289.173,173.517c-1.037,5.472-1.685,16.711,1.318,38.959h27.115c.187-4.154-2.426-24.444,1.584-44.035a71.286,71.286,0,0,0-9.072-1.145,100.607,100.607,0,0,0-11.52,0c-1.267.115-2.52.3-3.6.5A7.2,7.2,0,0,0,289.173,173.517Z",
    transform: "translate(-279.677 -138.633)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2613",
    "data-name": "Path 2613",
    d: "M293.322,186.814l-4.9-1.174c-.151,2.966-.166,6.638.05,11.182C290.73,194.258,293.61,190.255,293.322,186.814Z",
    transform: "translate(-279.679 -143.815)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2614",
    "data-name": "Path 2614",
    d: "M301.99,392.77l.259,6.048h5.069l-.259-6.048Z",
    transform: "translate(-283.508 -201.812)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2615",
    "data-name": "Path 2615",
    d: "M352.524,390.63,347.57,391.7l2.563,5.63,4.954-1.073Z",
    transform: "translate(-296.271 -201.212)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2616",
    "data-name": "Path 2616",
    d: "M314.066,140.782c-1.3,4.853-1.814,7.762-4.81,9.778-4.5,3.067-10.116-.446-10.26-5.573-.158-4.63,1.994-11.794,7.2-12.773a6.854,6.854,0,0,1,7.87,8.568Z",
    transform: "translate(-282.668 -128.823)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2617",
    "data-name": "Path 2617",
    d: "M303.857,141.463c-.245-.648-1.361-5.666-.31-6.97s13.039-.36,14.81,1.382c2.945,2.88.9,5.472-2.318,8.806-2.419,2.506-2.513,5.328-3.737,5.76-2.16.72-5.458.043-6.12-2.239S303.857,141.463,303.857,141.463Z",
    transform: "translate(-283.82 -129.324)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2618",
    "data-name": "Path 2618",
    d: "M315.865,128.392c-4.234-1.8-12.175.194-16.466-.842a6.61,6.61,0,0,0,5.479,6.739,56.63,56.63,0,0,0,10.8,1C320.386,135.074,319.465,129.926,315.865,128.392Z",
    transform: "translate(-282.781 -127.55)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2619",
    "data-name": "Path 2619",
    d: "M323.19,136.527a8.071,8.071,0,0,0,4.486-.857C328.468,137.585,324.112,138.111,323.19,136.527Z",
    transform: "translate(-289.444 -129.824)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2620",
    "data-name": "Path 2620",
    d: "M305.82,143.872a5.7,5.7,0,0,1-1.44,3.362c-1.109,1.217-2.261.454-2.455-1.022-.173-1.339.187-3.6,1.541-4.248S305.913,142.367,305.82,143.872Z",
    transform: "translate(-283.478 -131.531)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2621",
    "data-name": "Path 2621",
    d: "M304.69,230.134s5.76,38.7,8.906,53.2c3.449,15.876,21.982,68.4,21.982,68.4l9.065-1.966s-12.96-42.811-15.84-65.009c-2.232-17.05-6.617-54.641-6.617-54.641Z",
    transform: "translate(-284.264 -156.27)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2622",
    "data-name": "Path 2622",
    d: "M344.57,394.064c-.036,0,1.692,3.283,1.692,3.283l10.2-2.21-.857-3.067Z",
    transform: "translate(-295.43 -201.616)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2623",
    "data-name": "Path 2623",
    d: "M309.158,249.269c6.646,1.3,5.94,26.086,5.141,38.837-1.915-9.014-4.723-26.352-6.638-38.657A2.268,2.268,0,0,1,309.158,249.269Z",
    transform: "translate(-285.096 -161.616)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2624",
    "data-name": "Path 2624",
    d: "M291.2,230.129s-.72,37.865-.144,53.28c.576,16.063,6.185,68.659,6.185,68.659h8.582s.31-51.66.72-67.435c.418-17.194,2.491-54.533,2.491-54.533Z",
    transform: "translate(-280.383 -156.264)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2625",
    "data-name": "Path 2625",
    d: "M297.439,394.8c-.043,0,.482,3.557.482,3.557h10.433l.288-3.175Z",
    transform: "translate(-282.233 -202.38)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2626",
    "data-name": "Path 2626",
    d: "M297.244,175.481c2.426,6.545-11.837,14.256-11.837,14.256l-6.178-7.92s4.154-8.222,9.194-11.923C294.652,165.329,295.394,170.5,297.244,175.481Z",
    transform: "translate(-277.135 -138.912)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2627",
    "data-name": "Path 2627",
    d: "M297.244,175.481c2.426,6.545-11.837,14.256-11.837,14.256l-6.178-7.92s4.154-8.222,9.194-11.923C294.652,165.329,295.394,170.5,297.244,175.481Z",
    transform: "translate(-277.135 -138.912)",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Thinking--inject-119",
    transform: "translate(236.707 60.998)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 25.985,
    cy: 16.56,
    rx: 25.985,
    ry: 16.56,
    transform: "translate(12.254)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2628",
    "data-name": "Path 2628",
    d: "M366.035,92.239a7.279,7.279,0,0,1-7.15-6.041,7.358,7.358,0,0,1,5.551-8.294h0a7.243,7.243,0,0,1,7.79,3.254l16.682-3.442a2.606,2.606,0,0,1,3.053,1.793,2.513,2.513,0,0,1-1.922,3.1l-.432.086a.425.425,0,0,0-.3.223.454.454,0,0,0,0,.374l.3.763a1.145,1.145,0,0,1-.446,1.39,1.368,1.368,0,0,0-.641,1.015,1.13,1.13,0,0,1-.871,1l-.338.072a1.123,1.123,0,0,1-1.2-.576,1.4,1.4,0,0,0-2.6.54,1.116,1.116,0,0,1-.864.994l-.338.072a1.13,1.13,0,0,1-1.2-.576,1.44,1.44,0,0,0-1-.677,1.145,1.145,0,0,1-1.008-1.13v-.821a.446.446,0,0,0-.533-.418l-5.321,1.094a7.25,7.25,0,0,1-5.724,6.048A7.459,7.459,0,0,1,366.035,92.239Zm-1.44-13.68a6.631,6.631,0,0,0-5.04,7.5,6.559,6.559,0,0,0,12.96-.374v-.259l5.868-1.188a1.166,1.166,0,0,1,1.44,1.094v.821a.425.425,0,0,0,.346.41,2.1,2.1,0,0,1,1.519,1.03.418.418,0,0,0,.425.23l.331-.072a.4.4,0,0,0,.3-.374,2.124,2.124,0,0,1,3.96-.835.41.41,0,0,0,.418.23l.346-.072a.4.4,0,0,0,.3-.374,2.088,2.088,0,0,1,.986-1.548.439.439,0,0,0,.151-.518l-.3-.763a1.159,1.159,0,0,1,.85-1.555l.439-.094a1.807,1.807,0,0,0,1.375-2.21,1.879,1.879,0,0,0-2.218-1.274L371.9,81.928l-.13-.223a6.48,6.48,0,0,0-7.142-3.132Zm1.44,11a4.427,4.427,0,1,1,.936-.058h0a4.586,4.586,0,0,1-.929.072Zm0-8.5a4.32,4.32,0,0,0-.8.079,3.905,3.905,0,0,0,1.627,7.639h0a3.9,3.9,0,0,0,1.354-7.063,3.83,3.83,0,0,0-2.153-.641Z",
    transform: "translate(-337.17 -67.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 8.539,
    cy: 5.443,
    rx: 8.539,
    ry: 5.443,
    transform: "translate(8.554 31.946)",
    fill: "#90caf9",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 3.506,
    cy: 2.232,
    rx: 3.506,
    ry: 2.232,
    transform: "translate(0 40.601)",
    fill: "#90caf9",
    opacity: 0.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPwd);
export default __webpack_public_path__ + "static/media/forgot_pwd.da56eea80089172556c96db99d3b541c.svg";
export { ForwardRef as ReactComponent };